module.exports = __webpack_public_path__ + "media/dashboard/plyny-menu-8cfbb5ed.svg";